import React from 'react'
import { Button } from 'components/ui'
import { HiPlusCircle } from 'react-icons/hi'
import EmailTemplateTableSearch from './EmailTemplateTableSearch'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';


const EmailTemplateTableTools = () => {
	
	const { t } = useTranslation();
	return (
		<div className="flex flex-col lg:flex-row md:gap-4 lg:gap-0 lg:items-center">
			<EmailTemplateTableSearch />
			 
			<Link 
				className="block lg:inline-block md:mb-0 mb-4"
			 	to="/cms/Email/EmailTemplate/Add" 
			>
				<Button
					block
					variant="solid"
					size="sm" 
					icon={<HiPlusCircle />}
				>
					{t('translation.register')}
				</Button>
			</Link>
		</div>
	)
}

export default EmailTemplateTableTools